import { URL } from "../../api/Api";
import { catchError, GET, PUT } from "../axios/Axios";

export const AutomationGetCall = async () => {
  try {
    const response = await GET(`${URL}/automation/settings/`, {});
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const AutomationUpdate = async (payload) => {
  try {
    const response = await PUT(`${URL}/automation/settings/`, payload, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};
